// extracted by mini-css-extract-plugin
export default {"heading":"styles-module__heading__fec0348f309dad114aab"};